export default "__VITE_ASSET__UoE2SNbc__"